import {useState, createRef, useEffect} from 'react'
import {Input, Form} from 'antd'

const OTPInput = ({onChange}: any) => {
  const [otp, setOtp] = useState(new Array(6).fill(''))
  const inputRefs = Array(6)
    .fill(0)
    .map(() => createRef<any>())

  const finish = () => {
    onChange(otp.join(''))
  }

  useEffect(() => {
    // Check if all OTP fields have been filled
    const allFilled = otp.every(val => val)
    // if (allFilled) {
    finish()
    // }
  }, [otp]) // This effect runs every time the otp state changes

  const handleChange = (element: any, index: any) => {
    const value = element.value
    const newOtp = [...otp]
    newOtp[index] = value.substring(value.length - 1, value.length)

    if (value.length === 1 && index < 5) {
      inputRefs[index + 1].current.focus()
    }

    setOtp(newOtp)
  }

  const handleKeyDown = (e: any, index: any) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs[index - 1].current.focus()
    }
  }

  const handlePaste = (e: any) => {
    e.preventDefault()
    const pasteData = e.clipboardData.getData('text').slice(0, 6).split('')
    if (pasteData.length === 6) {
      setOtp(pasteData)
      inputRefs[5].current.focus()
    }
  }

  return (
    <Form.Item>
      <Input.Group compact>
        {otp.map((data, index) => (
          <Input
            className="otp-input"
            maxLength={1}
            key={index}
            value={data}
            onChange={e => handleChange(e.target, index)}
            onKeyDown={e => handleKeyDown(e, index)}
            ref={inputRefs[index]}
            onPaste={handlePaste}
            style={{
              width: '40px',
              textAlign: 'center',
              height: '40px',
              marginRight: '8px',
              borderRadius: '8px',
            }}
          />
        ))}
      </Input.Group>
    </Form.Item>
  )
}

export default OTPInput
